import { render, staticRenderFns } from "./HolidayAssignmentNew.vue?vue&type=template&id=141a369e"
import script from "./HolidayAssignmentNew.vue?vue&type=script&lang=js"
export * from "./HolidayAssignmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports